 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","about":"about","access-forbidden":"access-forbidden","add-payment":"add-payment","assigned-students":"assigned-students","availability":"availability","certificate":"certificate","chat-inbox":"chat-inbox","chat-thread":"chat-thread","courses":"courses","dashboard~instructor-profile~notifications~search~student-bookings~student-notifications":"dashboard~instructor-profile~notifications~search~student-bookings~student-notifications","dashboard~instructor-profile~notifications~student-bookings~student-notifications":"dashboard~instructor-profile~notifications~student-bookings~student-notifications","dashboard~instructor-profile~notifications":"dashboard~instructor-profile~notifications","dashboard":"dashboard","instructor-profile":"instructor-profile","notifications":"notifications","student-bookings~student-notifications":"student-bookings~student-notifications","student-bookings":"student-bookings","student-notifications":"student-notifications","package-details~search":"package-details~search","search":"search","forgot-password":"forgot-password","get-started":"get-started","login":"login","maintenance":"maintenance","package-details":"package-details","packages":"packages","packages-plan":"packages-plan","payments":"payments","questionnaire":"questionnaire","requested-bookings":"requested-bookings","reviews":"reviews","settings":"settings","student-dashboard":"student-dashboard","student-profile":"student-profile","support":"support","zipcode":"zipcode"}[chunkId]||chunkId) + "." + {"404":"3d08bd34","about":"81891c29","access-forbidden":"c32bb29e","add-payment":"1deed862","assigned-students":"1d4e85bb","availability":"8034b428","certificate":"efef1749","chat-inbox":"e3435b6e","chat-thread":"613afe9a","chunk-2c8a64ae":"fe9a8378","chunk-2d216214":"1f54003d","courses":"0eb18fbd","dashboard~instructor-profile~notifications~search~student-bookings~student-notifications":"0ca4e7bb","dashboard~instructor-profile~notifications~student-bookings~student-notifications":"fdcff9b7","dashboard~instructor-profile~notifications":"2d24c316","dashboard":"9a1033c0","instructor-profile":"01666b6c","notifications":"882c42d4","student-bookings~student-notifications":"5678d435","student-bookings":"ad072f70","student-notifications":"590bcfea","package-details~search":"306e983f","search":"1ac8255b","forgot-password":"b3c17ba0","get-started":"0bae9cd9","login":"c1490bde","maintenance":"51380599","package-details":"2689e0da","packages":"3a3ab645","packages-plan":"f798eee2","payments":"20381490","questionnaire":"c227d198","requested-bookings":"a4dd5e5c","reviews":"ad2760f9","settings":"f6672b36","student-dashboard":"ceb6d70a","student-profile":"fb6a1075","support":"2d09b591","zipcode":"e9c40a39"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"add-payment":1,"assigned-students":1,"availability":1,"chat-inbox":1,"courses":1,"dashboard~instructor-profile~notifications~search~student-bookings~student-notifications":1,"dashboard~instructor-profile~notifications~student-bookings~student-notifications":1,"dashboard~instructor-profile~notifications":1,"instructor-profile":1,"student-bookings~student-notifications":1,"package-details~search":1,"search":1,"forgot-password":1,"get-started":1,"login":1,"maintenance":1,"package-details":1,"packages-plan":1,"payments":1,"questionnaire":1,"requested-bookings":1,"reviews":1,"settings":1,"student-dashboard":1,"student-profile":1,"zipcode":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","about":"about","access-forbidden":"access-forbidden","add-payment":"add-payment","assigned-students":"assigned-students","availability":"availability","certificate":"certificate","chat-inbox":"chat-inbox","chat-thread":"chat-thread","courses":"courses","dashboard~instructor-profile~notifications~search~student-bookings~student-notifications":"dashboard~instructor-profile~notifications~search~student-bookings~student-notifications","dashboard~instructor-profile~notifications~student-bookings~student-notifications":"dashboard~instructor-profile~notifications~student-bookings~student-notifications","dashboard~instructor-profile~notifications":"dashboard~instructor-profile~notifications","dashboard":"dashboard","instructor-profile":"instructor-profile","notifications":"notifications","student-bookings~student-notifications":"student-bookings~student-notifications","student-bookings":"student-bookings","student-notifications":"student-notifications","package-details~search":"package-details~search","search":"search","forgot-password":"forgot-password","get-started":"get-started","login":"login","maintenance":"maintenance","package-details":"package-details","packages":"packages","packages-plan":"packages-plan","payments":"payments","questionnaire":"questionnaire","requested-bookings":"requested-bookings","reviews":"reviews","settings":"settings","student-dashboard":"student-dashboard","student-profile":"student-profile","support":"support","zipcode":"zipcode"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","about":"31d6cfe0","access-forbidden":"31d6cfe0","add-payment":"06c7830c","assigned-students":"b964e408","availability":"35ca581b","certificate":"31d6cfe0","chat-inbox":"26499d03","chat-thread":"31d6cfe0","chunk-2c8a64ae":"31d6cfe0","chunk-2d216214":"31d6cfe0","courses":"78ae0f77","dashboard~instructor-profile~notifications~search~student-bookings~student-notifications":"a2c5c721","dashboard~instructor-profile~notifications~student-bookings~student-notifications":"02a15bac","dashboard~instructor-profile~notifications":"aae64fc9","dashboard":"31d6cfe0","instructor-profile":"78ae0f77","notifications":"31d6cfe0","student-bookings~student-notifications":"55111fff","student-bookings":"31d6cfe0","student-notifications":"31d6cfe0","package-details~search":"a03b6555","search":"01b03cad","forgot-password":"78ae0f77","get-started":"01b03cad","login":"b22b010c","maintenance":"f33e21e8","package-details":"e17c73a6","packages":"31d6cfe0","packages-plan":"2b29dccd","payments":"57af936f","questionnaire":"01b03cad","requested-bookings":"6a3593f7","reviews":"5faf6d6f","settings":"fe71cb84","student-dashboard":"aa67d8c3","student-profile":"0369c3a5","support":"31d6cfe0","zipcode":"2b29dccd"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
